import api from './api';

// SWR fetcher function
export const fetcher = async (url: string) => {
  const response = await api.get(url);
  return response.data;
};

// SWR fetcher for POST requests
export const postFetcher = async (url: string, data?: any) => {
  const response = await api.post(url, data);
  return response.data;
};

// SWR fetcher for PUT requests
export const putFetcher = async (url: string, data?: any) => {
  const response = await api.put(url, data);
  return response.data;
};

// SWR fetcher for DELETE requests
export const deleteFetcher = async (url: string) => {
  const response = await api.delete(url);
  return response.data;
};

